(function () {
  const SELECTORS = {
    root: "[data-mb-menu-panel-tabs]",
    tabBtn: "[data-mb-menu-panel-btn]",
    panel: "[data-mb-menu-panel]",
  };

  function initMenuTabs(root) {
    if (root.dataset.mbTabsInitialized === "true") return;

    const buttons = Array.from(
      root.querySelectorAll(SELECTORS.tabBtn)
    ).filter((button) => button.closest(SELECTORS.root) === root);

    const panels = Array.from(
      root.querySelectorAll(SELECTORS.panel)
    ).filter((panel) => panel.closest(SELECTORS.root) === root);

    if (!buttons.length || !panels.length) return;

    root.dataset.mbTabsInitialized = "true";

    const buttonsContainer = root.querySelector(
      ".mb-menu-panel__tabs-btns"
    );

    const panelsContainer = root.querySelector(
      ".mb-menu-panel__tabs-containers"
    );

    const mobileQuery = window.matchMedia("(max-width: 989px)");

    function setOpenId(id) {
      buttons.forEach((button) => {
        const isOpen = button.dataset.mbMenuPanelBtn === id;

        button.setAttribute("aria-open", String(isOpen));
        button.setAttribute("aria-expanded", String(isOpen));
      });

      panels.forEach((panel) => {
        const isOpen = panel.dataset.mbMenuPanel === id;

        panel.setAttribute("aria-open", String(isOpen));
        panel.hidden = !isOpen;
      });

      root.classList.toggle("has-open-panel", Boolean(id));
    }

    function updateLayout() {
      if (!buttonsContainer || !panelsContainer) return;

      if (mobileQuery.matches) {
        buttons.forEach((button) => {
          const panel = panels.find(
            (item) =>
              item.dataset.mbMenuPanel ===
              button.dataset.mbMenuPanelBtn
          );

          if (panel) {
            button.insertAdjacentElement("afterend", panel);
          }
        });
      } else {
        panels.forEach((panel) => {
          panelsContainer.appendChild(panel);
        });
      }
    }

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const isOpen =
          button.getAttribute("aria-expanded") === "true";

        setOpenId(isOpen ? null : button.dataset.mbMenuPanelBtn);
      });
    });

    root.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;

      const openButton = buttons.find(
        (button) => button.getAttribute("aria-expanded") === "true"
      );

      if (!openButton) return;

      event.preventDefault();
      event.stopPropagation();

      setOpenId(null);
      openButton.focus();
    });

    function onViewportChange() {
      if (!root.isConnected) {
        mobileQuery.removeEventListener("change", onViewportChange);
        return;
      }

      updateLayout();
    }

    mobileQuery.addEventListener("change", onViewportChange);

    updateLayout();
    setOpenId(null);
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(SELECTORS.root)) {
      initMenuTabs(scope);
    }

    scope.querySelectorAll(SELECTORS.root).forEach(initMenuTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initAll(),
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();